/**
 * Why a shipment ends up in the attention queue.
 *
 * The values are the backend's `reason` parameter verbatim, and each one maps
 * to the same predicate the dashboard's card counts with — that is what keeps
 * the number on the card and the rows on this page from ever disagreeing.
 */
export const ATTENTION_REASON = {
  ALL: 'all',
  STALLED: 'stalled',
  WITHOUT_TRACKING: 'without_tracking',
  FAILED: 'failed',
  RETURNING: 'returning',
};

/** The backend's `DASHBOARD_STALLED_DAYS`: how long "Sin moverse" waits. */
export const STALLED_AFTER_DAYS = 3;

/**
 * `label` is what the chip says; `description` explains the rule, because
 * "estancado" is a threshold somebody chose and the screen should say which.
 */
export const ATTENTION_REASONS = [
  {
    value: ATTENTION_REASON.ALL,
    label: 'Todos',
    description: 'Todo lo que necesita una mirada',
    tone: 'neutral',
  },
  {
    value: ATTENTION_REASON.STALLED,
    label: 'Sin moverse',
    // The one reason the date range does not narrow, so it has to say so.
    description: `Envíos abiertos que llevan más de ${STALLED_AFTER_DAYS} días sin cambiar de estado, sin importar las fechas elegidas`,
    tone: 'warning',
  },
  {
    value: ATTENTION_REASON.WITHOUT_TRACKING,
    label: 'Sin tracking',
    description: 'Ni el envío ni ninguno de sus bultos tiene número de seguimiento',
    tone: 'neutral',
  },
  {
    value: ATTENTION_REASON.FAILED,
    label: 'Fallidas',
    description: 'Entregas que no pudieron completarse',
    tone: 'danger',
  },
  {
    value: ATTENTION_REASON.RETURNING,
    label: 'En devolución',
    description: 'Envíos que van de vuelta',
    tone: 'warning',
  },
];

export const ATTENTION_REASON_MAP = ATTENTION_REASONS.reduce((map, reason) => {
  map[reason.value] = reason;
  return map;
}, {});
